module.exports = __webpack_public_path__ + "static/media/fir_ext_wat.ab13fb69.png";